'use strict';

export const paymentOptionsElements = () => ({
    container: document.querySelector('div#payment-options'),
    amountButtons: document.querySelectorAll('div#payment-options div#buttons button[data-amount]'),
    monthlySingleButtons: document.querySelectorAll('div#payment-options div#monthly-single button[data-option]'),
    singlePaymentButton: document.querySelector('div#payment-options div#monthly-single button[data-option=single]'),
    other: document.querySelector('div#payment-options div#other-input'),
    donationAmount: document.querySelector('div#payment-options input[name=donationAmount]'),
    donationAmountSelect: document.querySelector('div#payment-options input[name=donationAmountSelect]'),
    singleOrMonthlyPayment: document.querySelector('div#payment-options input[name=singleOrMonthlyPayment]'),
    validationError: document.querySelector('div#validation'),
    montlySingleRow: document.querySelector('div#monthly-single')
});
